import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import DeviceNeedingPatch from './DeviceNeedingPatch';

const DeviceNeedingPatchPage = () => {
  return (
    <div className="flex min-h-screen bg-[var(--Background-Color,rgb(7,7,7))]  text-white">
      {/* Sidebar */}
      <Sidebar />

      {/* Right Panel */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header title="Device Needing Patch" dropdown={2} showBackButton />

        {/* Main Content */}

        <DeviceNeedingPatch />
      </div>
    </div>
  );
};

export default DeviceNeedingPatchPage;
